import React from 'react';
import { Hero } from './components/Hero';
import { SalesSection } from './components/SalesSection';
import { ProductsSection } from './components/ProductsSection';
import { Testimonials } from './components/Testimonials';
import { SocialProofPopup } from './components/SocialProofPopup';
import { FloatingWhatsApp } from './components/FloatingWhatsApp';
import { CTAButton } from './components/CTAButton';
import { BannerCarousel } from './components/BannerCarousel';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <main className="min-h-screen w-full bg-white font-sans text-gray-900 selection:bg-[#FF6B35] selection:text-white" data-id="element-0">
      {/* Meta Pixel */}
      <MetaPixel data-id="element-1" />

      <Hero data-id="element-2" />

      {/* TOP BANNERS */}
      <BannerCarousel data-id="element-3" />

      {/* 1. QUID NO BLOQUEA, QUID FILTRA */}
      <SalesSection title="QUID no bloquea. QUID filtra." className="bg-gradient-to-br from-orange-50 to-white" data-id="element-4">
        <div className="mb-8 rounded-2xl bg-white p-8 shadow-lg" data-id="element-5">
          <p className="mb-6 text-center text-2xl font-bold text-[#FF6B35]" data-id="element-6">
            -16 dB de reducción pareja
          </p>
          <div className="grid gap-4 sm:grid-cols-3" data-id="element-7">
            {['Menos impacto', 'Más claridad', 'Música viva'].map((item, i) => <div key={i} className="text-center" data-id="element-8">
                <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-full bg-[#FF6B35]/10" data-id="element-9">
                  <span className="text-2xl" data-id="element-10">✓</span>
                </div>
                <p className="font-medium" data-id="element-11">{item}</p>
              </div>)}
          </div>
        </div>
        <p className="text-center text-lg" data-id="element-12">
          Es como bajar el brillo de la pantalla, no apagarla.
        </p>
        <div className="mt-8 text-center" data-id="element-13">
          <CTAButton href="#compra" data-id="element-14">Ver productos</CTAButton>
        </div>
      </SalesSection>

      {/* 2. QUID ES PARA VOS SI... */}
      <SalesSection title="QUID es para vos si..." dark className="bg-black" data-id="element-15">
        <div className="grid gap-4 sm:grid-cols-2" data-id="element-16">
          {['Salís seguido a boliches o festivales', 'Sos DJ, productor o staff de eventos', 'Amás la música fuerte sin pagar el precio', 'Ya sentiste zumbido o fatiga auditiva'].map((item, i) => <div key={i} className="flex items-center gap-3 rounded-lg bg-white/5 p-4 backdrop-blur-sm" data-id="element-17">
              <span className="text-2xl text-[#FF6B35]" data-id="element-18">✓</span>
              <span className="text-base" data-id="element-19">{item}</span>
            </div>)}
        </div>
      </SalesSection>

      {/* 2.5. IMAGINATE ESTA ESCENA */}
      <div className="relative overflow-hidden bg-black py-20 text-white" data-id="element-20">
        <div className="absolute inset-0 z-0 opacity-30" data-id="element-21">
          <img src="https://images.unsplash.com/photo-1574169208507-84376144848b?q=80&w=2079&auto=format&fit=crop" alt="Party vibe" className="h-full w-full object-cover" data-id="element-22" />
          <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" data-id="element-23"></div>
        </div>

        <div className="relative z-10 mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8" data-id="element-24">
          <h2 className="mb-12 text-3xl font-bold sm:text-4xl" data-id="element-25">
            Imaginate esta escena
          </h2>

          <div className="space-y-8" data-id="element-26">
            <p className="text-xl" data-id="element-27">
              Entrás al boliche. Arranca el set. Te ponés QUID.
            </p>
            <p className="text-2xl font-bold text-[#FF6B35]" data-id="element-28">
              El volumen baja... pero la música sigue clara.
            </p>

            <div className="mx-auto grid max-w-2xl gap-6 rounded-2xl bg-white/10 p-8 backdrop-blur-sm sm:grid-cols-2" data-id="element-29">
              <div data-id="element-30">
                <p className="mb-3 font-bold text-[#FF6B35]" data-id="element-31">Esa noche:</p>
                <ul className="space-y-2 text-left" data-id="element-32">
                  <li data-id="element-33">✓ Disfrutás sin pensar</li>
                  <li data-id="element-34">✓ Te quedás hasta el final</li>
                  <li data-id="element-35">✓ Bailás sin culpa</li>
                </ul>
              </div>
              <div data-id="element-36">
                <p className="mb-3 font-bold text-[#FF6B35]" data-id="element-37">
                  Al día siguiente:
                </p>
                <ul className="space-y-2 text-left" data-id="element-38">
                  <li data-id="element-39">✓ Sin pitido</li>
                  <li data-id="element-40">✓ Sin resaca auditiva</li>
                  <li data-id="element-41">✓ Cero arrepentimiento</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 3. ELEGÍ TUS FILTROS (PRODUCTOS) */}
      <ProductsSection data-id="element-42" />

      {/* 4. EN QUÉ SE DIFERENCIAN LOS QUID */}
      <SalesSection title="¿En qué se diferencian los QUID con el resto de los filtros?" data-id="element-43">
        <div className="grid gap-4 sm:grid-cols-2" data-id="element-44">
          <div className="rounded-lg bg-red-50 p-6" data-id="element-45">
            <h3 className="mb-4 text-lg font-bold text-red-600" data-id="element-46">
              Tapones comunes:
            </h3>
            <ul className="space-y-3" data-id="element-47">
              {['Bloquean el sonido al azar', 'Distorsionan la música', 'Apagan el bajo', 'Te sacan del ambiente'].map((item, i) => <li key={i} className="flex items-center gap-3 text-sm text-gray-700" data-id="element-48">
                  <span className="text-xl text-red-500" data-id="element-49">✕</span>
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="rounded-lg bg-orange-50 p-6" data-id="element-50">
            <h3 className="mb-4 text-lg font-bold text-[#FF6B35]" data-id="element-51">QUID:</h3>
            <ul className="space-y-3" data-id="element-52">
              {['Reducción pareja de -16dB', 'Mantiene la música clara', 'El bajo se siente igual', 'Seguís en el ambiente'].map((item, i) => <li key={i} className="flex items-center gap-3 text-sm text-gray-700" data-id="element-53">
                  <span className="text-xl text-[#FF6B35]" data-id="element-54">✓</span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
        <p className="mt-6 text-center text-lg font-bold" data-id="element-55">
          QUID filtra, no bloquea. Esa es la diferencia.
        </p>
      </SalesSection>

      {/* 5. TESTIMONIALS */}
      <Testimonials data-id="element-56" />

      {/* 6. UNA VERDAD INCÓMODA + ORIGIN STORY */}
      <section className="bg-black py-20 px-4 text-center text-white sm:px-6 lg:px-8" data-id="element-57">
        <div className="mx-auto max-w-3xl" data-id="element-58">
          <h2 className="mb-8 text-3xl font-bold sm:text-4xl" data-id="element-59">
            Una verdad incómoda
          </h2>

          <p className="mb-4 text-xl" data-id="element-60">
            Si salís seguido, QUID es más importante que el outfit.
          </p>
          <p className="mb-8 text-2xl font-bold text-[#FF6B35]" data-id="element-61">
            Tus oídos te quedan.
          </p>

          <div className="mb-12 space-y-3" data-id="element-62">
            {['"Este pitido no me gusta"', '"No quiero quedarme sordo"', '"Quiero seguir saliendo años más"'].map((quote, i) => <p key={i} className="text-lg text-gray-300" data-id="element-63">
                {quote}
              </p>)}
          </div>

          {/* ORIGIN STORY */}
          <div className="mb-12 rounded-2xl bg-white/5 p-8 backdrop-blur-sm" data-id="element-64">
            <p className="mb-4 text-xl font-medium text-[#FF6B35]" data-id="element-65">
              QUID surge en cabinas, boliches y festivales.
            </p>
            <p className="text-2xl font-bold" data-id="element-66">Por y para ravers.</p>
          </div>

          <h3 className="mb-8 text-4xl font-extrabold leading-tight sm:text-6xl" data-id="element-67">
            Bajá el volumen.
            <br data-id="element-68" />
            <span className="text-[#FF6B35]" data-id="element-69">No la experiencia.</span>
          </h3>

          <CTAButton href="#compra" variant="primary" data-id="element-70">
            Conseguir QUID ahora
          </CTAButton>
        </div>
      </section>

      {/* FINAL BANNER */}
      <section className="bg-white py-16" data-id="element-71">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-72">
          <div className="overflow-hidden rounded-2xl shadow-2xl" data-id="element-73">
            <img src="https://cdn.magicpatterns.com/uploads/2fKjhUBQopkM7MjEaoinHQ/Banner_final_de_la_web.webp" alt="Summer '26 - Para que no te quemes, cuidate del sol y del ruido" className="w-full h-auto object-cover" data-id="element-74" />
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-gray-800 bg-gray-900 py-12 px-4 text-center text-gray-400" data-id="element-75">
        <p className="mb-4 text-2xl font-bold tracking-tighter text-white" data-id="element-76">
          Quid
        </p>
        <p className="text-sm" data-id="element-77">
          © {new Date().getFullYear()} Quid Argentina. Todos los derechos
          reservados.
        </p>
        <p className="mt-4 text-xs opacity-50" data-id="element-78">
          Disfrutá la música sin quemarte los oídos (-16 dB)
        </p>
      </footer>

      <SocialProofPopup data-id="element-79" />
      <FloatingWhatsApp data-id="element-80" />
    </main>;
}